import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import HistoricoOrdemDeServicoItemService from "./HistoricoOrdemDeServicoItemService";

export default {

    async alterarItem(ordemDeServicoItemValores = {}){

        let ordemDeServicoItem;

        try{

            //==================================================================//
            //============ Cria Historico da Ordem de Servico Item =============//
            //==================================================================//

            let ordemDeServicoID = ordemDeServicoItem?.data?.id;

            let historicoOrdemDeServicoItem = await HistoricoOrdemDeServicoItemService.criarHistorico(ordemDeServicoID);
            if(historicoOrdemDeServicoItem.status != 200){
                throw historicoOrdemDeServicoItem;
            }

            //==================================================================//
            //================== Altera Ordem de Serviço Item ==================//
            //==================================================================//

            ordemDeServicoItem = await ERP.patchOne(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItemValores);
            if(ordemDeServicoItem.status != 200){
                throw ordemDeServicoItem;
            }

            console.log(ordemDeServicoItem);

            // //==================================================================//
            // //================= Obtem Ordens de Servico Itens ==================//
            // //==================================================================//

            // ordemDeServicoItem = await ERP.getOneById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoID);
            // if(ordemDeServicoItem.status != 200){
            //     throw ordemDeServicoItem;
            // }

        }catch(e){

            console.log(e);
            return ordemDeServicoItem;

        }

        return ordemDeServicoItem;

    },

    async alterarItens(ordemDeServicoItensValores = []){

        let ordemDeServicoItens;

        try{

            //==================================================================//
            //=========== Cria Historico das Ordens de Servico Itens ===========//
            //==================================================================//

            let ordensDeServicoItensIDs = ordemDeServicoItensValores?.map(({id})=> id);

            let historicoOrdemDeServicoItens = await HistoricoOrdemDeServicoItemService.criarHistoricos(ordensDeServicoItensIDs);
            if(historicoOrdemDeServicoItens.status != 200){
                throw historicoOrdemDeServicoItens;
            }

            //==================================================================//
            //================= Altera Ordens de Serviço Itens =================//
            //==================================================================//

            ordemDeServicoItens = await ERP.patchMany(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItensValores);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }
         
            // //==================================================================//
            // //================= Obtem Ordens de Servico Itens ==================//
            // //==================================================================//

            // ordemDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordensDeServicoItensIDs);
            // if(ordemDeServicoItens.status != 200){
            //     throw ordemDeServicoItens;
            // }

            console.log(ordemDeServicoItens);

        }catch(e){

            console.log(e);
            return ordemDeServicoItens;

        }

        return ordemDeServicoItens;

    }

}